import { z } from "zod";
// Define the CallStatus enum using Zod
export const CallStatusEnum = z.enum([
    "pending_scheduling",
    "scheduled",
    "scheduling_failed",
    "oauth_failed",
    "in_progress",
    "processed",
    "failed",
    "cancelled",
]);
export const CallSchema = z.object({
    id: z.string(),
    orgId: z.string().optional(), // Making optional for now if not always present from all sources
    userId: z.string().optional(), // Making optional for now
    meetingUrl: z.string().nullable(), // Renamed from url, made nullable
    recallBotId: z.string().nullable(), // Made nullable
    deduplicationKey: z.string().nullable(), // Store the last used deduplication key
    callScriptId: z.string().optional().nullable(), // Kept optional, made nullable
    status: CallStatusEnum, // Use the Zod enum for status
    summary: z.string().nullable(), // Added summary
    startTime: z.string(), // Added startTime (assuming it's a string like ISO date)
    endTime: z.string().nullable(), // Planned end time from calendar
    callEndedAt: z.string().nullable(), // Actual end time when call ended
    originatingCalendarEventId: z.string().nullable(), // Added
    // Add derived fields for better UX
    hasRecordingStarted: z.boolean().optional(),
    recordingStartedAt: z.string().nullable().optional(),
    latestRecallStatus: z.string().nullable().optional(),
    hasAnalysisAvailable: z.boolean().optional(),
    mediaAvailable: z.boolean().optional(),
    mediaExpiredAt: z.string().nullable().optional(),
    // recallData: z.record(z.unknown()).nullable(), // Consider if this is needed in shared, often large
    createdAt: z.string(), // Kept createdAt
    updatedAt: z.string().optional(), // Added updatedAt, making optional
});
// Participant roles - these are business logic roles assigned by our application
// NOT from Recall.ai API - see ParticipantRoleService and callParticipantRoles table
export const ParticipantRoleSchema = z.enum([
    "salesperson",
    "client",
    "observer",
]);
export const CallParticipantSchema = z.object({
    id: z.string(),
    name: z.string(),
    email: z.string(),
    avatarUrl: z.string().optional(),
});
// Call Event (combination of participant and active speaker events)
export const ParticipantJoinEventSchema = z.object({
    event: z.literal("bot.participant_join"),
    data: z.object({
        bot_id: z.string(),
        participant_id: z.number(),
        created_at: z.string(),
    }),
});
export const ParticipantLeaveEventSchema = z.object({
    event: z.literal("bot.participant_leave"),
    data: z.object({
        bot_id: z.string(),
        participant_id: z.number(),
        created_at: z.string(),
    }),
});
export const ActiveSpeakerNotifyEventSchema = z.object({
    event: z.literal("bot.active_speaker_notify"),
    data: z.object({
        bot_id: z.string(),
        participant_id: z.number(),
        created_at: z.string(),
    }),
});
export const ParticipantInWaitingRoomEventSchema = z.object({
    event: z.literal("bot.participant_in_waiting_room"),
    data: z.object({
        bot_id: z.string(),
        participant_id: z.number(),
        created_at: z.string(),
    }),
});
// Call Question
export const CallQuestionSchema = z.object({
    id: z.string(),
    question: z.string(),
    context: z.string(),
    timestamp: z.number(),
    isAnswered: z.boolean(),
    speakerId: z.number(),
    isFinalized: z.boolean(),
});
